import { render, staticRenderFns } from "./TagsDialog.vue?vue&type=template&id=42c69271&"
import script from "./TagsDialog.vue?vue&type=script&lang=js&"
export * from "./TagsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TagsDialog.vue"
export default component.exports